/**
 * 用于记录课堂视频播放节点用的
 */
import { getCookie } from '@/utils/cookie';
import { isAndroid, isIOS } from '@/utils/env';
import { request } from '@/services/index';
const LOG_API =
    location.host == 'vision-beta.test.gifshow.com' ||
    location.host == 'm-vision.ketang.kuaishou.com'
        ? 'https://log-ketang.kuaishou.com'
        : 'https://lightks.staging.kuaishou.com';
function getDeviceInfo() {
    const did = getCookie('did');
    const system = getCookie('sys');
    const ud = getCookie('ud');
    const model = getCookie('mod');
    const version = getCookie('ver');
    const language = getCookie('language');
    const deviceInfo = {
        did,
        system,
        ud,
        model,
        version,
        language,
    };
    // console.log(deviceInfo);
    return deviceInfo;
}
function getPublicParams() {
    const deviceInfo = getDeviceInfo();
    if (!deviceInfo) {
        return;
    }
    const pps = {
        app: 'ksapp',
        platform: '',
        ...deviceInfo,
    };
    if (isIOS) {
        pps.platform = 'IOS';
    } else if (isAndroid) {
        pps.platform = 'Android';
    } else {
        pps.platform = 'Web';
    }
    return pps;
}

function req_post(url, data) {
    const pps = getPublicParams();
    const arr = [] as string[];
    for (const key in pps) {
        const val = pps[key];
        arr.push(`${key}=${val}`);
    }
    // for (let [key, val] of Object.entries(pps)) {
    //     arr.push(`${key}=${val}`);
    // }
    if (arr.length > 0) {
        url += `?${arr.join('&')}`;
    }
    request.post(url, data);
}

export const makeActionLog = (bizName, getServerExpTag = () => ({})) => {
    return async function (data) {
        const expTag = await getServerExpTag();
        let defaultsExtParams = {
            ...expTag, // { serverExpTag: 'XX', clientExpTag: 'XXX'}
            fullpath: location.href,
        };
        try {
            const extParams = JSON.parse(data.extParams);
            defaultsExtParams = Object.assign({}, defaultsExtParams, extParams);
        } catch (err) {
            // console.log(err);
        }
        const defaultsParam2 = {
            extParams: JSON.stringify(defaultsExtParams),
        };
        data = Object.assign(data, defaultsParam2);
        req_post(`${LOG_API}/rest/lightks/wd/log/reportLog`, {
            logInfos: [data],
            bizName,
        });
    };
};
